<template>
  <div class="saas-feature section-space--ptb_90 bg-gray">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title text-center section-space--mb_60">
            <h2 class="font-weight--light mb-15 wow move-up" style="font-size: 48px;">Developed for Higher Business
              Growth</h2>
            <span class="section-text wow move-up">All-in-one automation software for you.</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
          <div class="service-grid">
            <div class="ht-service-box--one style-03">
              <router-link :to="'branding'">
                <div class="image__media">
                  <img :src="item.icon" class="img-fluid"
                       alt="aeroland-app-showcase-box-icon-image-01">
                </div>
                <div class="content">
                  <h6 class="heading">{{ item.heading }}</h6>
                  <div class="service_text">{{ item.text }}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'SassFeature',
        data() {
            return {
                items: [
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-01.png'),
                        heading: 'Make New Connections',
                        text: 'Widen your network. Select thousands of prospects. Write an introduction message or use templates. Insert personalization. Let the system notify you once the connection is accepted .Launch and see your connections grow.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-02.png'),
                        heading: 'Discover New Opportunities',
                        text: 'Start new conversations with your 1st-degree network. Segment your connections based on your criteria. Engage, Personalize & Set up sequences. Sit back and watch new opportunities come in every day.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-03.png'),
                        heading: 'Get contact information',
                        text: 'Already have a strong network ? Run campaigns to get contact information with at least email or phone number based on search that you choose and export them or get them integrated into your CRM.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-04.png'),
                        heading: 'Endorse Skills',
                        text: 'Automatically endorse up top skills of your connections. Recognize and get recognition in return. Great way to give your profile an uplift.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-05.png'),
                        heading: 'Plugins Integration',
                        text: 'We already have a seamless integration with multiple CRMs, get the leads with their contact information into your CRM and focus only on your business.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-box-image-06.png'),
                        heading: 'LinkedIn Management',
                        text: 'YourSynchronicity is not like any other automation software, our first priority is to stay in safe limits, and protect your account from LinkedIn restrictions.'
                    },
                ]
            }
        }
    }
</script>
